/* eslint-env jquery */

'use strict';

jQuery( function( $ ) {
	const slider = $( '#webeezSlider' );
	slider.owlCarousel( {
		items: 1,
		loop: true,
		autoplay: true,
		autoplayTimeout : 6000,
		autoplaySpeed : 2500,
		navSpeed : 2500,
		autoHeight: true,
		responsive: {
			0: {
				nav  : false,
				dots : true,
			},
			992: {
				nav  : true,
				dots : false,
			},
		},
	} );

	slider.on( 'changed.owl.carousel', function() {
		slider.trigger( 'stop.owl.autoplay' );
		slider.trigger( 'play.owl.autoplay' );
	} );
} );
